import { AddPublicOrderMutationVariables } from '../../graphql/generated/graphql';
import { PanierState } from '../../types/panier/panier.def';
import { ClientFormValue } from '../../types/client/client.def';

const formatOrderForMutation = (
  client: ClientFormValue,
  panier: PanierState
): AddPublicOrderMutationVariables['order'] => {
  const { methodepaiement, ...rest } = client;
  const { contributionOng, ...restPanier } = panier;
  return {
    client: {
      ...rest
    },
    panier: {
      ...restPanier,
      customerContributedToTheOng: contributionOng.isContributing,
      commandeLines: panier.commandeLines.map(cml => ({
        produit: cml.produit.id,
        quantite: cml.quantite
      }))
    },
    methodepaiement: client.methodepaiement
  };
};
export default formatOrderForMutation;
